import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';

const TooltipWrapper = styled.span(({ theme, backgroundColor }) => [
  CommonStyles,
  `
  background-color: ${backgroundColor || (theme == null ? void 0 : theme.colors.textPrimary)};
  padding-top: ${theme == null ? void 0 : theme.spacing.s8};
  padding-bottom: ${theme == null ? void 0 : theme.spacing.s8};
  padding-left: ${theme == null ? void 0 : theme.spacing.s12};
  padding-right: ${theme == null ? void 0 : theme.spacing.s12};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
  max-width: 16rem;
  z-index: 100;
`
]);
const PopoverWrapper = styled.span(({ visibility = true, theme }) => [
  `
  background-color: ${theme == null ? void 0 : theme.colors.textPrimary};
  padding: ${theme == null ? void 0 : theme.spacing.s12};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
  max-width: 16rem;
  min-width: 12rem;
  visibility: ${visibility ? "visible" : "hidden"};
  &[data-popper-reference-hidden='true'] {
    visibility: hidden;
    pointer-events: none;
  }
`,
  CommonStyles
]);
const StyledArrow = styled.span(({ theme, backgroundColor }) => `
  position: absolute;
  width: 6px;
  height: 6px;
  &:after {
    content: ' ';
    position: absolute;
    pointer-events: none;
    width: 6px;
    height: 6px;
    background-color: ${backgroundColor || (theme == null ? void 0 : theme.colors.textPrimary)};
    transform: rotate(45deg);
  }
  &.arrow-bottom {
    bottom: -3px;
  }
  &.arrow-top {
    top: -3px;
  }
  &.arrow-left {
    left: -3px;
  }
  &.arrow-right {
    right: -3px;
  }
`);

export { PopoverWrapper, StyledArrow, TooltipWrapper };
